import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';

import { IdentityProvider, useIdentityProvidersQuery } from '@treams/treams-network';
import { Paragraph, Select, SelectProps } from '@treams/treams-ui';

type Props = {
	onChange: (identityProvider: IdentityProvider['id']) => void;
};

const BulkSSOIdentityProvider = ({ onChange }: Props) => {
	const { t } = useTranslation();

	const { data } = useIdentityProvidersQuery();
	const [selected, setSelected] = useState<SelectProps['selectedValue']>();

	const options: SelectProps['options'] = data?.identityProviders.map(({ id, configuration }) => {
		return { value: id, title: configuration?.name || id };
	});

	const handleChange = (provider: SelectProps['selectedValue']) => {
		if (provider) {
			setSelected(provider);
			onChange(provider);
		}
	};

	return (
		<Flex mb={3} flexDirection="row" alignItems="center">
			<Box flexGrow={1}>
				<Paragraph>{t('employees.bulkSSO.identityProvider.description')}</Paragraph>
			</Box>
			<Box flexShrink={0} flexGrow={0}>
				<Select
					placeholder={t('employees.bulkSSO.identityProvider.placeholder')}
					selectedValue={selected}
					options={options}
					onChange={(option) => handleChange(option)}
				/>
			</Box>
		</Flex>
	);
};

export default BulkSSOIdentityProvider;
